<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <b-button variant="danger" class="text-white" :disabled="exporting" v-on:click="showArchiveModal()"><i v-show="!exporting" class="fa fa-download"></i><i v-show="exporting" class="fa fa-spinner fa-spin"></i> Arquivar</b-button>
      <b-button variant="success" class="text-white" :disabled="exporting" v-on:click="exportGrid()"><i v-show="!exporting" class="fa fa-download"></i><i v-show="exporting" class="fa fa-spinner fa-spin"></i> Exportar</b-button>
      <router-link class="btn btn-primary" :to="{name:'registrations.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <Grid name="registrationsGrid" ref="registrationsGrid"  height="calc(100vh - 250px)"  :editable="false" :preload="preload" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
  <b-modal ref="downloadModal" id="downloadModal">
    O ficheiro está pronto:
    <a :href="fileDownload.url" target="_blank">{{ fileDownload.title }}</a>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-right" variant="primary" @click="hideModal">
        Close
      </b-btn>
    </div>
  </b-modal>
  <b-modal ref="archiveModal" id="archiveModal">
    <p v-if="!archiving">Vai mover todas as inscrições para o histórico.</p>
    <p v-if="archiving">A arquivar as inscrções.</p>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-left" variant="secondary" @click="hideModal">
        Cancelar
      </b-btn>
      <b-btn size="sm" class="float-right" variant="primary" @click="archive">
        Continuar
      </b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import States from '@/components/Lists.js'

export default {
  name: 'RegistrationsGrid',
  components: {
    Grid
  },
  data() {
    return {
      exporting: false,
      archiving: false,
      fileDownload: {
        url: '',
        title: ''
      },
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'birth_date': {
          type: 'date'
        },
        'id': {
          type: 'number',
          editable: false
        },
        activity_id: {
          type: 'number',
          editable: false
        },
        master_region_id: {
          type: 'number',
          editable: false
        },
        state: {
          type: 'number',
          editable: true
        },
        veteran: {
          type: 'number',
          editable: false
        },
        family_member_id: {
          type: 'number',
          editable: false
        },
        activity_year: {
          type: 'number',
          editable: false
        },
        'compound_key': {
          type: 'string',
          editable: false
        },
        'name': {
          type: 'string',
          editable: false
        },
        'nif': {
          type: 'string',
          editable: false
        },
        'surname': {
          type: 'string',
          editable: false
        }

      },
      url: 'registrations',
      preload: [{
        api: 'activities/lst',
        field: 'activity_id'
      }, {
        api: 'subactivities/lst',
        field: 'subactivity_id'
      },{
        api: 'regions/lst',
        field: 'region_id'
      },{
        api: 'master_regions/lst',
        field: 'master_region_id'
      }],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '80px',
        locked: true
      }, {
        field: 'compound_key',
        title: 'ID Participante',
        width: '140px',
        locked: true
      },
      {
        field: 'name',
        title: 'Participante',
        width: '380px',
        locked: true
      },
      {
        field: 'subactivity_id',
        title: 'Campo',
        width: '150px',
        locked: true
      },
      {
        field: 'activity_id',
        title: 'Escalão',
        width: '140px'
      },
      {
        field: 'state',
        title: 'Estado',
        width: '120px',
        values: States.registrationStates
      },
      {
        field: 'onhold',
        title: 'Lista de espera',
        width: '140px',
        values: States.yesNo
      },
      {
        field: 'activity_year',
        title: 'Ano',
        width: '120px'
      },
      {
        field: 'ranking',
        title: 'Ranking',
        width: '160px'
      },
      {
        field: 'family_id',
        title: 'ID Família',
        width: '120px'
      },
      {
        field: 'surname',
        title: 'Família',
        width: '180px'
      },
      {
        field: 'gender',
        title: 'Sexo',
        width: '120px',
        values: States.genders
      },
      {
        field: 'region_id',
        title: 'Região',
        width: '120px',
        values: []
      },
      {
        field: 'master_region_id',
        title: 'Região Principal',
        width: '120px',
        values: []
      },
      {
        field: 'veteran',
        title: 'Veterano',
        width: '120px',
        values: States.yesNo
      },
      {
        field: 'nif',
        title: 'NIF',
        width: '120px'
      },
      {
        field: 'family_phone',
        title: 'Contacto',
        width: '120px'
      },
      {
        field: 'birth_date',
        title: 'Data de nascimento',
        format: '{0:dd/MM/yyyy}',
        width: '120px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy'
            })
          }
        }
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      },  {
        field: 'id',
        title: 'Id',
        width: '80px',
        editable: false
      }]
    }
  },
  methods: {
    hideModal: function() {
      this.$refs.downloadModal.hide()
    },
    hideArchiveModal: function() {
      this.$refs.archiveModal.hide()
    },
    showArchiveModal: function() {
      this.$refs.archiveModal.show()
    },
    exportGrid: function() {
      this.exporting = true
      var grid = this.$refs.registrationsGrid.$refs.mygrid.kendoWidget()
      console.log(grid.getOptions())
      this.axios.post('registrations/export', {
        filter: grid.getOptions().dataSource.filter
      }).then(response => {
        this.fileDownload = response.data
        this.$refs.downloadModal.show()
        this.exporting = false
      }).catch(error => {
        this.$bvToast.toast('Houve um erro a exportar', { autoHideDelay: 5000, variant: 'danger', solid: true})
        this.exporting = false
      })
    },
    archive: function() {
      this.exporting = true
      this.archiving = true

      this.axios.post('registrations/archive', {})
        .then(response => {
          this.$bvToast.toast('Inscrições arquivadas', { autoHideDelay: 5000, variant: 'success', solid: true})
          this.hideArchiveModal();
          this.exporting = false
          this.archiving = false
          this.$refs.registrationsGrid.reload();
        }).catch(error => {
          this.hideArchiveModal();
          this.$bvToast.toast('Houve um erro a arquivar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          this.exporting = false
          this.archiving = false
        })
    },
    getBtnTemplate: function(item) {
      if (this.$auth.check('registrations.edit')) {
        var route = router.resolve({
          name: 'registrations.edit',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i></a>'
      } else if (this.$auth.check('registrations.view')) {
        var route = router.resolve({
          name: 'registrations.view',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
